<template>
	<div>
		<case-form :schema="schema" class="mt6" />
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
export default {
	components: {
		CaseForm
	},

	computed: {
		schema() {
			return [
				{
					label: `Name of Business/Employer`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerName`,
					props: {
						suggest: {
							typeIncludes: `employerName`
						},
						createOptions: {
							type: `employerName`,
							dataType: "string"
						}
					}
				},
				{
					label: `Nature of Business`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerNatureOfBusiness`,
					props: {
						suggest: {
							typeIncludes: `employerNatureOfBusiness`
						},
						createOptions: {
							type: `employerNatureOfBusiness`,
							dataType: "string"
						}
					}
				},
				{
					label: "Business/Employer Address",
					component: "entityAddress",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].addresses",
					bindTo: "case.facts.insured0employerAddress",
					props: {
						suggest: {
							typeIncludes: "employerAddress"
						},
						createOptions: {
							type: "employerAddress"
						}
					}
				},
				{
					label: `Occupation, Position Held`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0occupationPosition`,
					props: {
						suggest: {
							typeIncludes: `occupationPosition`
						},
						createOptions: {
							type: `occupationPosition`,
							dataType: "string"
						}
					}
				},
				{
					label: `Duties`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0occupationDuties`,
					props: {
						suggest: {
							typeIncludes: `occupationDuties`
						},
						createOptions: {
							type: `occupationDuties`,
							dataType: "string"
						}
					}
				},
				{
					label: `Website URL`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerWebsiteURL`,
					props: {
						suggest: {
							typeIncludes: `employerWebsiteURL`
						},
						createOptions: {
							type: `employerWebsiteURL`,
							dataType: "string"
						}
					}
				},
				{
					label: `Business Telephone`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerTelephoneNo`,
					props: {
						suggest: {
							typeIncludes: `employerTelephoneNo`
						},
						createOptions: {
							type: `employerTelephoneNo`,
							dataType: "string"
						}
					}
				},
				{
					label: `Business Fax`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0employerFaxNo`,
					props: {
						suggest: {
							typeIncludes: `employerFaxNo`
						},
						createOptions: {
							type: `employerFaxNo`,
							dataType: "string"
						}
					}
				}
			]
		}
	}
}
</script>
